export default __webpack_public_path__ + "c96659b4de38e84d9f8932cc71f18815.png";